import { css } from 'linaria';

export const root = css`
    position: absolute;
    border: 0;
    clip: rect(0 0 0 0);
    overflow: hidden;
    padding: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    white-space: nowrap;
    word-wrap: normal;
`;
